import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogout, setAdminToken, getAdminToken } from "@/lib/api";

const AuthCtx = createContext({
  user: null,
  loading: true,
  setUser: () => {},
  logout: async () => {},
  refresh: async () => {},
  hasPermission: () => false,
});

export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getAdminToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { user: u } = await authMe();
      setUser(u);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = useCallback(async () => {
    try { await authLogout(); } catch { /* ignore */ }
    setAdminToken(null);
    setUser(null);
    window.location.replace("/admin/login");
  }, []);

  const hasPermission = useCallback((perm) => {
    if (!user) return false;
    if (user.role === "owner") return true;
    return (user.permissions || []).includes(perm);
  }, [user]);

  return (
    <AuthCtx.Provider value={{ user, loading, setUser, logout, refresh, hasPermission }}>
      {children}
    </AuthCtx.Provider>
  );
}
